import React from 'react'

import {
    ModalAlertContent, ModalBox,
    ModalOnlyTitle, ModalWrap
} from 'src/styles/common/modal'

import {ModalBtn} from 'src/styles/common/CommonForm/buttonform'
import {COLOR} from 'src/service/constant/color'
import useWindowDimensions from "src/hooks/useGetWindowSize"
import {useRecoilValue,} from "recoil"
import {certCheck} from "src/store/recoil/common"

const DoubleModal = (props: any) => {
    const {isOpen, toggle, toggle2, option} = props
    const {width} = useWindowDimensions()
    const CertCheck = useRecoilValue(certCheck)
    const ClickFunc = () => {
        switch (true) {
            case CertCheck :
            case (option === "유효한 인증번호가 있습니다. 만료 후 인증번호 받기가 가능합니다.") :
            case (option === "서비스를 이용하신 이력(리워드, 기타 서비스 이용 등)이 있습니다.\n고객센터(1855-3631)로 문의해주세요."):
                toggle()
                toggle2()
                break;
            case (option === "비가입자 입니다."):
            case (option === "이미 서비스에 가입되어 있습니다.") :
            case (option === "죄송합니다.아이폰은 서비스를 지원하지 않아 서비스에 가입하실 수 없습니다."):
            case (option === "미성년자는 서비스 가입이 불가합니다."):
            case (option === "15세 미만 미성년자는 서비스가입이 불가합니다."):
            case (option === "앱을 통해 회원 탈퇴를 진행해주세요."):
            case (option === "휴대폰번호 또는 통신사를 확인하세요."):
            case (option === "보안문자 3회 오류로 만료되었습니다. 보안문자를 새로고침 해주세요."):
                window.location.reload()
                break;
            case (option === "가입되어 있지 않습니다. 문의사항이 있을 경우 고객센터(1855-3631)로 문의해주세요."):
            case (option === "휴대폰 번호를 확인하세요."):
                toggle()
                toggle2()
                window.location.reload()
                break;
            default:
                return toggle2()
        }
    }

    return (
        <ModalWrap toggle={isOpen} onClick={ClickFunc} zIndex={9999} width={`${width}px`}>
            <ModalBox onClick={(e: any) => e.stopPropagation()}>
                <ModalAlertContent>
                    <ModalOnlyTitle>{option}</ModalOnlyTitle>
                    <ModalBtn bgColor={COLOR.point1} onClick={ClickFunc}>
                        <span>확인</span>
                    </ModalBtn>
                </ModalAlertContent>
            </ModalBox>
        </ModalWrap>
    )
}
export default DoubleModal
